module.exports = __webpack_public_path__ + "static/image/history/pc/202308@x3.ver2_0_2.jpg?78ac6648";